import {Component} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from "rxjs/Observable";
import "rxjs/add/observable/fromPromise";
import {NotificationsService} from "../../../services/notifications.service";
import {Reservation, ReservationsService, ReservationSummary} from "../../../services/reservations.service";

@Component({
  selector: 'reservation-summary-modal',
  templateUrl: 'reservation-summary-modal.component.html'
})
export class ReservationSummaryModalComponent {
  reservation: Reservation;
  summary: ReservationSummary;
  errors: any = {};

  static open(modalService: NgbModal, reservation: Reservation): Observable<boolean> {
    const modalRef = modalService.open(ReservationSummaryModalComponent);
    modalRef.componentInstance.reservation = reservation;
    modalRef.componentInstance.summary = {
      comment: '',
    };
    return Observable.fromPromise(modalRef.result)
  }

  constructor(private activeModal: NgbActiveModal, private reservationService: ReservationsService, private notificationsService: NotificationsService) {
  }

  close() {
    this.activeModal.close(false);
  }

  confirm() {
    this.reservationService
      .submitSummary(this.reservation.id, this.summary)
      .subscribe(_ => {
        this.notificationsService.show('Dziękujemy za wypełnienie podsumowania.');
        this.activeModal.close(true);
      }, response => this.errors = JSON.parse(response.error));
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/reservation-summary-modal/reservation-summary-modal.component.ts